export { TrendsDrawer } from '@/components/trends/trends-drawer'
